import { useCookies } from 'react-cookie';

function useProjectId() {
  const [cookies] = useCookies(['projectId']);
  return cookies.projectId;
}

export default useProjectId;
